import { adminGet, adminPost, adminPatch, adminGetBlob, downloadBlob } from '../adminApi';

export const qrGet = (path) => adminGet(`/qr${path}`);
export const qrPost = (path, body) => adminPost(`/qr${path}`, body);
export const qrPatch = (path, body) => adminPatch(`/qr${path}`, body);

export async function openPdf(path) {
  const blob = await adminGetBlob(`/qr${path}`);
  window.open(URL.createObjectURL(blob), '_blank', 'noopener');
}

export async function downloadFile(path, filename) {
  downloadBlob(await adminGetBlob(`/qr${path}`), filename);
}

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }) : '—');
